// constants
import type { ReactNode } from 'react';

// types
import type { IconType } from '@sdb/planning-ui/ui-3/packages/icons/__generated__';

export enum ContextPanelNavigationItemType {
  LOG,
  TASK_LIST,
  WAITING_LIST
}

export enum ContextPanelSize {
  COMPACT = 45,
  MEDIUM = 300,
  LARGE = 500
}

export type ContextPanelProps = {
  onClose?: () => void;
  onOpen?: () => void;
  onPanelSizeChange?: (panelSize: ContextPanelSize) => void;
  isAppointmentOpen?: boolean;
};

export type ContextPanelNavigationProps = {
  panelSize: ContextPanelSize;
  onMenuItemChange: (menuItem: ContextPanelMenuItem) => void;
};

export type ContextPanelMenuItem = {
  id: ContextPanelNavigationItemType;
  icon: IconType;
  component?: ReactNode;
  label: string;
};
export type ContextPanelHeaderProps = {
  label: string;
  onPanelSizeChange?: (panelSize: ContextPanelSize) => void;
};

export type ContextPanelStore = {
  hasHydrated: boolean;
  panelSize: ContextPanelSize;
  prevPanelSize: ContextPanelSize;
  control: {
    setPanelSize: (panelSize: ContextPanelSize) => void;
  };
};
